var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-pagination',_vm._b({staticClass:"right-pager",attrs:{"current-page":_vm.$data.current,"page-size":_vm.$data.size,"layout":_vm.layout,"total":_vm.total},on:{"size-change":(val) => { _vm.handleSizeChange(val) },"current-change":(val) => { _vm.handleCurrentChange(val) }}},'el-pagination',_vm.$attrs,false))
}
var staticRenderFns = []

export { render, staticRenderFns }